

import boxOneImg from "../../../assets/artificial-intelligence 1.svg";
import boxTwoImg from "../../../assets/authenticity 2.svg";
import boxThreeImg from "../../../assets/blackboard 1.svg";


export const FEATURES = [
    {
        featureButton:"Features",
        title:"Write Humanised Content with AI",
        description:"Whether it's kickstarting a new article or adding flair to existing content, our AI writer is trained on millions of data points to generate creative content for you just like you would yourself!",
        featureImages:boxOneImg
    },
    {
        featureButton:"Features",
        title:"Absolute Originality",
        description:" Confidently present your work, knowing our tool has cross-referenced it against billions of documents, certifying its uniqueness",
        featureImages:boxTwoImg
    },
    {
        featureButton:"Features",
        title:"Flawless Grammar",
        description:"Utilize sophisticated algorithms that delve deep into language nuances, ensuring each sentence you write radiates professionalism and precision",
        featureImages:boxThreeImg
    }
]